import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AutocompleteField from '../../../../../FormControl/input/AutocompleteField';
import IconTooltipButton from '../../../../../button/IconTooltipButton';
import { useParams } from 'react-router-dom';
import useMarking from '../../../../../../hooks/maestro/useMarking';
import useLearningGrowth from '../../../../../../hooks/maestro/useLearningGrowth';

const StudentsSelector = ({ type }) => {
  const { studentId } = useParams();
  const { getStudentMarkingByClassIdAndUlId, updateStudentMarkingByClassIdAndUlId } = useMarking();
  const { updateStudentLearningGrowth } = useLearningGrowth();
  const completed = useSelector((state) => state?.classMarking.completedType);
  const completedLG = useSelector((state) => state?.classMarking.learningGrowthType);
  
  const dispatch = useDispatch();
  const userId = useSelector((state) => state?.session?.user?.userId || '');

  const permissions = useSelector((state) => state?.session?.permissions?.['marking-class'] || {});
  const students = useSelector((state) => state?.classMarking?.students);
  const student = useSelector((state) => state?.classMarking?.student);
  const onChangeStudent = useCallback(
    (newStudent) => {
      updateStudentMarkingByClassIdAndUlId(student);
      getStudentMarkingByClassIdAndUlId(newStudent);
    },
    [student, completed]
  );

  const handlePreviousStudent = () => {
    const { index } = student;
    if (students[index - 1]) {
      onChangeStudent(students[index - 1], completed);
    }
  };

  const handleNextStudent = () => {
    const { index } = student;
    if (students[index + 1]) {
      onChangeStudent(students[index + 1], completed);
    }
  };

  useEffect(() => {
    if (studentId && !student) {
      const find = students.find((item) => item._id === studentId);
      if (find) {
        onChangeStudent(find, completed);
      }
    }
  }, [studentId, students, student, onChangeStudent]);

  useEffect(() => {
    if (permissions['by-student'] && userId && !student) {
      const find = students.find((item) => item._id === userId);
      if (find) {
        onChangeStudent(find, completed);
      }
    }
  }, [permissions, students, student]);

  useEffect(() => {
    if (student && type === 'learning-growth') {
      updateStudentLearningGrowth(student, completedLG);
    }
  }, [completedLG, type, student]);

  if (!permissions['student-selector']) return <></>;

  return (
    <div className='flex flex-col gap-2 py-2'>
      <AutocompleteField
        id='select-student'
        value={{}}
        className='capitalize'
        placeholder='Choose a student'
        onChange={(el) => onChangeStudent(el, completed)}
        options={[...students].sort((a, b) => a.code - b.code)}
      />
      <div className='flex items-center justify-between'>
        <IconTooltipButton
          title='Previous'
          icon='chevron-left'
          classNameIcon='text-lg'
          color='primary'
          style={{
            width: 25,
            height: 25
          }}
          disabled={students.length === 0 || student?.index === 0 || student?.index === undefined}
          onClick={handlePreviousStudent}
        />
        <IconTooltipButton
          title='Next'
          icon='chevron-right'
          classNameIcon='text-lg'
          color='primary'
          style={{
            width: 25,
            height: 25
          }}
          disabled={
            students.length === 0 || students.length - 1 === student?.index || student?.index === undefined
          }
          onClick={handleNextStudent}
        />
      </div>
    </div>
  );
};

export default StudentsSelector;
